/**
 * Electron main loads this file with Node.
 * Keep it free of relative imports. Node cannot resolve an extensionless import from here.
 */
export const velisNatsumeCardId = 'velis-natsume'
export const velisAtriCardId = 'velis-atri'

export const velisNatsumeDisplayModelId = 'velis-natsume-rlmlr'
export const velisAtriDisplayModelId = 'velis-atri-live2d'

export const velisPackagedDisplayModels = [
  {
    id: velisNatsumeDisplayModelId,
    cardId: velisNatsumeCardId,
    fileName: 'rlmlr.live2d.zip',
    relativePath: '.velis/characters/natsume/display/rlmlr.live2d.zip',
  },
  {
    id: velisAtriDisplayModelId,
    cardId: velisAtriCardId,
    fileName: 'atri.live2d.zip',
    relativePath: '.velis/characters/atri/display/atri.live2d.zip',
  },
] as const
